<template>
  <div tabindex="0" class="modal-container" @click="handleClick" @keyup.esc="$emit('clickOutsideOfModal')">
    <div class="auth-modal" ref="modal">
      <div v-if="section === 'signup' && this.storePlan">
        <div>
          <h2 class="section-title mt-1">Crear cuenta</h2>
          <SignupForm @dataIsValid="handleSignUp" :requestError="error" />

          <div class="toggle-section">¿Tienes una cuenta? <span class="toggle-section-text"
              @click="handleToggleSection('login')">Iniciar
              sesión</span>
          </div>
        </div>
      </div>
      <div v-else-if="section === 'login' || !this.storePlan">
        <h2 class="section-title mt-2">Iniciar sesión</h2>
        <LoginForm @dataIsValid="handleLogin" :requestError="error" />
        <div class="toggle-section " v-if="this.storePlan">¿No tienes una cuenta? <span class="toggle-section-text"
            @click="handleToggleSection('signup')">Regístrate</span></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'pinia';
import useAuth from '../store/auth';
import planStore from '../store/plan';
import LoginForm from './loginForm.vue';
import SignupForm from './signupForm.vue';

export default {
  name: "modal-container",
  data() {
    return {
      section: "signup",
      error: ''
    };
  },
  props: {
    storePlan: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions(useAuth, ['login', 'signup']),
    ...mapActions(planStore, ['createPlan', 'updateCurrentPlanData']),
    async handleSignUp(userData) {
      this.error = ''
      try {
        const user = await this.signup(userData);
        let plan;
        if (user) {
          plan = await this.createPlan()
        }
        this.$emit('finishAuth')
        if (plan){
          await this.updateCurrentPlanData(null, 'returnToDefault')
          this.$router.push({ name: "plan-list" })
        }
      } catch (e) {
        this.error = 'Hubo un error, intente de nuevo más tarde'
        throw e
      }
    },
    async handleLogin(userData) {
      this.error = ''
      try {
        const user = await this.login(userData);
        let plan;
        if (user && this.storePlan) {
          plan = await this.createPlan()
        }
        if(plan){
          await this.updateCurrentPlanData(null, 'returnToDefault')
        }

        if (plan || (user && !this.storePlan)) {
          this.$router.push({ name: "plan-list" })
        }

        this.$emit('finishAuth')
      } catch (e) {
        if (e?.response?.data?.message === 'Bad user/password combination' || e?.response?.data?.message === 'User not found') {
          this.error = 'El usuario y/o la contraseña no son correctos'
        } else {
          this.error = 'Hubo un error, intente de nuevo más tarde'
        }
        throw e
      }
    },
    handleClick(e) {
      if (!this.$refs.modal?.contains(e.target) && e.target.classList.value == "modal-container") {
        this.$emit("clickOutsideOfModal");
      }
    },
    handleToggleSection(section) {
      this.section = section;
    }
  },
  components: { SignupForm, LoginForm }
}
</script>
<style scoped>
.section-title {
  font-weight: 700;
  color: var(--dark-gray);
}

.toggle-section {
  display: flex;
  justify-content: center;
  gap: 5px;
  user-select: none;
  margin-top: 10px;
}

.toggle-section-text {
  font-weight: 700;
  color: var(--dark-gray);
  cursor: pointer;
}

.auth-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 47rem;
  height: 47rem;
  background-color: white;
  z-index: 1;
  border-radius: var(--main-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}

.modal-container {
  width: 100%;
  height: 100%;
  background-color: #d9d9d9db;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
}


@media screen and (max-width: 700px) {

  .section-title {
    font-weight: 500;
    display: flex;
    justify-content: center;
    font-size: 1.2rem;
    width: 100%;
    padding-bottom: 10%;
  }

  .toggle-section {
    display: flex;
    justify-content: center;
    gap: 4px;
    user-select: none;
    margin-top: 8px;
  }

  .toggle-section-text {
    font-weight: 700;
    color: var(--dark-gray);
    cursor: pointer;
  }

  .auth-modal {
    height: 75%;
    width: 22rem;
  }

  .modal-container {
    width: 100%;
    height: 100%;
    background-color: #d9d9d9db;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
  }

}

</style>